/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from '../../components/index';
import { connect } from 'react-redux';
import {
  DtpContentContainer,
  DtpNoContent,
  DtpTabGroup,
  DtpTab,
} from 'dtp-react-components';
import validarCNPJ from '../../utils/validator/cnpjValidator';
import ProtectedItem from '../../components/ComponentesAutenticacao/ProtectedItem';
import DadosRepositorioCtc from './DadosRepositorioCtc';
import CtcDestinacao from './templates/CtcDestinacao';
import {
  doGet, doPost, doPut, trataMensagensErro, trataMensagemSucesso, buscaDestinatarios, validateObject
} from '../../utils/requests';
import CtcAtividade from './templates/CtcAtividade';
import * as listUtils from '../../utils/listsSelect';

/** ESTRUTURA DE ARQUIVOS UTILIZADOS NA CTC
 * RepositorioCtc
 * - DadosRepositorioCtc
 * CtcDestinacao
 * - MultiplasDestinacoes
 * -- ModalDestinacao
 * CtcAtividade
 * - MultiplasAtividades
 * -- ModalAtividades
 * --- ModalTemposERemuneracoes
 * --- ModalExibirModalRemuneracoesPreenchidas
 * ---- RemuneracaoControl
 * ----- DadosRemuneracaoControl
 * ------- RemuneracaoControlItem
 */
// const TAMANHO_MAX_COLECAO_COM_UMA_MATRICULA = 2;
// const TAMANHO_MAX_COLECAO_COM_DUAS_MATRICULAS = 3;
const VAZIO = '';
const NOME_RGPS = 'RGPS';
const CODIGO_RGPS = '01000';

class RepositorioCtc extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    ctc: {
      cpf: null,
      matricula1: null,
      dtAdmissaoMat1: null,
      dtDemissaoMat1: null,
      matricula2: null,
      dtAdmissaoMat2: null,
      dtDemissaoMat2: null,
      cnpjEmissor: null,
      nomeEmissor: null,
      cnpjHomologador: null,
      nomeHomologador: null,
      dtEmissao: null,
      tipoCtc: null,
      nome: null,
      dtNascimentoRequerente: null,
      sexo: null,
      nit: null,
      identidade: null,
      identidadeEmissor: null,
      identidadeUf: null,
      nomeMae: null,
      nomeMaeInexistente: 0,
      protocoloEmissor: null,
      dtCadastro: null,
      nomeCadastrador: null,
      dtInvalidacao: null,
      nomeInvalidador: null,
      destinacoes: [],
      atividades: [],
      nomeServidorEmissor: null,
      matriculaServidorEmissor: null,
      nomeServidorHomologador: null,
      matriculaServidorHomologador: null,
    },
    cpfTouched: false,
    validadeCampos: {
      cpf: false,
      nomeEmissor: false,
      protocoloEmissor: false,
      dtEmissao: false,
      tipoCtc: false,
      nome: false,
      dtNascimentoRequerente: false,
      sexo: false,
      cnpjEmissor: false,
      matricula1: false,
      cnpjEmissor: false,
      nit: false,
      // nomeServidorEmissor: false,
    },
    informarSegundaMatricula: 0,
    acao: 'novo',
    estadoFormulario: 'inicial',
    showNoContent: false,
    noContentPrimaryMessage: 'CTC não encontrada para o cpf informado.',
    noContentSecondaryMessage: 'Informe uma ctc válida.',
    showModalAlerta: false,
    exibirPainelAtividades: false,
    destinacoesTempoCertificado: [],
    listaMatriculasCadastradas: [],
    alertas: [],
    linhasDestinacaoDesabilitar: [],
    participantesEscolhidos: [],
    alerta: {
      codigo: null,
      descricao: null,
      mensagem: null,
      tipo: null,
    },
    operacao: null,
    desabilitarCheckboxSegundaMatricula: false,
    desabilitarCheckboxNomeMaeInexistente: false,
    desabilitarBotoesAcao: false,
    atividadeTemporaria: null,
    requestPesquisa: null,
  });

  componentDidMount() {
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.handleErrorBuscaCtc);
    }

    this.preencherCampoCpfVindoDoFiltro();
    this.preencherCampoProtocoloVindoDoFiltro();

    if (this.verificarAcaoFormulario()) {
      this.setState({
        acao: this.props.match.params.acao,
      }, this.direcionarRequest());
    }
  }

  direcionarRequest = () => {
    switch (this.props.match.params.acao) {
      case 'novo':
        return this.handleSearch(this.props.match.params.cpf);
      case 'editar-rascunho':
        return this.handleSearch(this.props.match.params.cpf);
      case 'detalhar-ctc':
        return this.handleSearchCtc(this.props.match.params.protocolo, this.props.match.params.situacao);
      case 'detalhar-ctc-invalida':
        return this.handleSearchCtcInvalida(this.props.match.params.protocolo);
      case 'revisar-ctc':
        return this.handleSearchCtcRevisao(this.props.match.params.protocolo);
      default:
        return false;
      }
  }

  verificarAcaoFormulario = () => {
    switch (this.props.match.params.acao) {
    case 'novo':
      return true;  
    case 'editar-rascunho':
      return true;
    case 'detalhar-ctc':
      return true;
    case 'detalhar-ctc-invalida':
      return true;
    case 'revisar-ctc':
      return true;
    default:
      return false;
    }
  }

  validarPreenchimentoCpf = () => {
    let { validadeCampos } = { ...this.state };
    validadeCampos.cpf = true;

    this.setState({
      validadeCampos,
    });
  }

  preencherCampoProtocoloVindoDoFiltro = () => {
    const { ctc } = { ...this.state };
    const protocoloVindoDoFiltro = this.props.match.params.protocolo;
    if (protocoloVindoDoFiltro) {
      this.setState({
        ctc: { ...ctc,
          protocoloComprev: protocoloVindoDoFiltro,
        }
      });
    }
  }

  preencherCampoCpfVindoDoFiltro = () => {
    const { ctc } = { ...this.state };
    const cpfVindoDoFiltro = this.props.match.params.cpf;
    if (cpfVindoDoFiltro) {
      this.setState({
        ctc: { ...ctc,
          cpf: cpfVindoDoFiltro,
        }
      }, this.validarPreenchimentoCpf());
    }
  }

  preparaNovaConsulta = () => {
    sessionStorage.removeItem('filtroRepositorioCtc');
  }

  marcarCheckboxSegundaMatricula = (matricula1, matricula2) => {
    let marcar = 0;
    if(matricula1 && matricula2){
      marcar = 1;
    }
    return marcar;
  }

  montaValidadeCampos = (ctc) => {
    let { validadeCampos } = { ...this.state };
    Object.keys(ctc).forEach((key) => {
      if (ctc[key] !== null && (key in validadeCampos)) {
        validadeCampos[key] = true;
      }
    });
    return validadeCampos;
  }

  verificarItemInseridoNaLista = (lista, indice) => {
    let retorno = -1;
    const index = lista.findIndex(item => (item.indiceDestinacao === indice));
    if (index !== -1) {
      retorno = index;
    }
    return retorno;
  }

  carregarListaDestinacoesDesabilitar = (ctc) => {
    let destinacoes = ctc.destinacoes;
    let atividades = ctc.atividades;
    let temposCertificadosCadastrados = [];
    let retorno = [];

    if ((atividades !== null && atividades !== undefined) && atividades.length > 0) {
      atividades.forEach((atividade) => {
        if(atividade.temposCertificados) {
          atividade.temposCertificados.forEach((tempoCertificado) => {
            temposCertificadosCadastrados.push(tempoCertificado);
          });
        }
      });
    }

    if ((destinacoes !== null && destinacoes !== undefined) && destinacoes.length > 0) {
      if (temposCertificadosCadastrados.length > 0 && destinacoes.length > 0) {
        temposCertificadosCadastrados.forEach((tempoCertificado) => {
          retorno.push(this.verificarItemInseridoNaLista(destinacoes, tempoCertificado.indiceDestinatario));
        });
      }
    }
    return retorno;
  }

  verificarTipoEntidade = (objetoIndex) => {
    return objetoIndex.tipoRegimeProprio;
  }

  popularListaParticipantesEscolhidos = (ctc) => {
    // USADO PARA RECUPERAR OS IDS DO PARTICIPANTE PARA CARREGAR A TELA NA HORA DE ALTERAR A DESTINAÇÃO
    let { acao } = { ...this.state };
    let participantesEscolhidos = [];

    if ((['detalhar-ctc', 'detalhar-ctc-invalida', 'editar-rascunho', 'revisar-ctc'].includes(acao))) {
      let destinacoes = ctc.destinacoes;
      let { destinatarios } = { ...this.props };

      if (destinacoes && destinacoes.length > 0 ) {
        destinacoes.forEach((ctcDestinacao) => {
          const index = destinatarios.findIndex(destinatarios => (destinatarios.value === ctcDestinacao.codigoParticipante));
          if (index !== -1) {
            const objetoIndex = destinatarios[index];
            let participanteEscolhido = {
              codigoParticipante: ctcDestinacao.codigoParticipante === NOME_RGPS ? CODIGO_RGPS : ctcDestinacao.codigoParticipante,
              tipoRegime: ctcDestinacao.codigoParticipante === CODIGO_RGPS ? 1 : 2,
              tipoEntidade: this.verificarTipoEntidade(objetoIndex),
              uf: destinatarios[index].uf ? destinatarios[index].uf : null,
            };
            participantesEscolhidos.push(participanteEscolhido);
          }
        });
      }
    }

    this.setState({
      participantesEscolhidos,
    });

    return participantesEscolhidos;
  }

  atualizarParticipantesEscolhidosAposExcluir = (row) => {
    let { participantesEscolhidos } = { ...this.state };
    if(participantesEscolhidos.length > 0) {
      participantesEscolhidos.splice(row, 1);
    }
    this.handleChange({ value: participantesEscolhidos, isValid: true }, 'participantesEscolhidos');
  }

  addSiglaMoedaLabel = (codigo) => {
    return listUtils.getObject(listUtils.moedas, codigo).label;
  }

  recuperarSiglaMoeda = (lista) => {
    let atividades = lista;
    if (atividades && atividades.length > 0) {
      atividades.forEach((atividade) => {
        if(atividade.remuneracoes && atividade.remuneracoes.length > 0) {
          atividade.remuneracoes.forEach((remuneracao) => {
            remuneracao.siglaMoeda = this.addSiglaMoedaLabel(remuneracao.tipoMoeda);
            // retorno.push(remuneracao);
          });
        }
      });
    }
    return atividades;
  }

  montaFormulario = (response) => {
    const { ctc } = { ...this.state };
    let { validadeCampos } = { ...this.state };
    let { informarSegundaMatricula } = { ...this.state };
    let { linhasDestinacaoDesabilitar } = { ...this.state };
    let { participantesEscolhidos } = { ...this.state };

    validadeCampos = this.montaValidadeCampos(response.data);
    informarSegundaMatricula = this.marcarCheckboxSegundaMatricula(response.data.matricula1, response.data.matricula2);
    linhasDestinacaoDesabilitar = this.carregarListaDestinacoesDesabilitar(response.data);
    participantesEscolhidos = this.popularListaParticipantesEscolhidos(response.data);

    ctc.atividades = this.recuperarSiglaMoeda(response.data.atividades);
    
    this.setState({
      ctc: { ...ctc, ...response.data },
      estadoFormulario: 'alterar',
      informarSegundaMatricula,
      validadeCampos,
      linhasDestinacaoDesabilitar,
      participantesEscolhidos,
    });
  }

  montaFormularioDadosCpf = (response) => {
    const { ctc } = { ...this.state };
    let { validadeCampos } = { ...this.state };
    validadeCampos = this.montaValidadeCampos(response.data);

    const dataNascimento = response.data.dataNascimento;
    if (dataNascimento !== null && dataNascimento !== '') {
      ctc.dtNascimentoRequerente = dataNascimento;
      validadeCampos.dtNascimentoRequerente = true;
    }

    this.setState({
      ctc: { ...ctc, ...response.data },
      validadeCampos,
    });
  }

  handleErrorBuscaCtc = () => {
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: 'Não foi possível realizar a consulta.',
      mensagemSecundariaSemConteudo: 'Contate o administrador do sistema.',
    });
  };

  verificaTamanhoLista = (lista, nome) => {
    let retorno = false;
    if (lista) {
      if(nome !== null && nome === 'atividades') {
          if (lista.length > 0) {
            lista.forEach((obj) => {
            if (obj.temposCertificados.length === 0) {
              return false;
            } else {
              retorno = true;
            }
          });
        }
      } else {
        if (lista.length > 0) {
          retorno = true;
        }
      }
      return retorno;
    }
  }

  handleKeyDown = (e) => {
    let retorno = null;
    if (e.keyCode === 13) {
      retorno = this.handleSearchButton();
    }
    return retorno;
  }

  formularioProntoParaEnvio = () => {
    const { destinacoes } = { ...this.state.ctc };
    const { atividades } = { ...this.state.ctc };
    const { acao } = { ...this.state };
    const { estadoFormulario } = { ...this.state };

    switch (acao) {
      case 'novo':
        if (estadoFormulario === 'sucesso-vazio' || estadoFormulario === 'ctc-ja-emitida-para-a-matricula') {
          return (this.verificaTamanhoLista(destinacoes, null) &&
            this.verificaTamanhoLista(atividades, 'atividades')) &&
            validateObject(this.state.validadeCampos);
        }
      case 'editar-rascunho':
        if (estadoFormulario === 'alterar' || estadoFormulario === 'criado') {
          return (this.verificaTamanhoLista(destinacoes, null) &&
            this.verificaTamanhoLista(atividades, 'atividades')) &&
            validateObject(this.state.validadeCampos);
          // return validateObject(this.state.validadeCampos);
        }
      case 'revisar-ctc':
        if (estadoFormulario === 'alterar') {
          return (this.verificaTamanhoLista(destinacoes, null) &&
            this.verificaTamanhoLista(atividades, 'atividades')) &&
            validateObject(this.state.validadeCampos);
          //return validateObject(this.state.validadeCampos);
        }     
      default:
        return false;
    }
  }

  rascunhoProntoParaEnvio = () => {
    const { destinacoes } = { ...this.state.ctc };
    return (this.verificaTamanhoLista(destinacoes, null) && validateObject(this.state.validadeCampos));
  }

  handleChange = (changeObj, name) => {
    const { ctc } = { ...this.state };
    if (name === 'exibirPainelDestinacao' ||
      name === 'atividadeTemporaria' ||
      name === 'participantesEscolhidos') {
        this.setState({
          [name]: changeObj.value,
        });
    } else {
      this.setState({
        ctc: {
          ...ctc,
          [name]: changeObj.value,
        },
        validadeCampos: {
          ...this.state.validadeCampos,
          [name]: changeObj.isValid,
        },
      });
    }
  }
  
  handleChangeCheckbox = (changeObj, name) => {
    const { ctc } = { ...this.state };
    switch (name) {
      // cliquei no checkbox nomeMaeInexistente com o campo nomeMae preenchido
      case 'nomeMaeInexistente':
        if (ctc.nomeMae !== null || ctc.nomeMae !== VAZIO) {
          ctc.nomeMae = VAZIO;
          this.setState({
            ctc: {
              ...ctc,
              [name]: changeObj.value,
            },
          });
        } else {
          this.setState({
            [name]: changeObj.value,
          });
        }
        break;
      case 'informarSegundaMatricula':
        // cliquei no checkbox informarSegundaMatricula com o campo informarSegundaMatricula preenchido
        if (ctc.matricula2 !== null || ctc.matricula2 !== VAZIO) {
          ctc.matricula2 = VAZIO;
          ctc.dtAdmissaoMat2 = VAZIO;
          ctc.dtDemissaoMat2 = VAZIO;
          this.setState({
            [name]: changeObj.value,
          });
        }
        break;
      default:
        break;
    }
  }

  handleChangeComboboxAuxiliar = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  verificarDesabilitarCheckboxSegundaMatricula = () => {
    const { ctc } = { ...this.state };
    let retorno = false;
    const possuiTresDestinacoes = (ctc.destinacoes !== null && ctc.destinacoes.length === 3);
    if (ctc.matricula1 !== null && ctc.matricula2 !== null && possuiTresDestinacoes) {
      retorno = true;
    } 
    this.setState({
      desabilitarCheckboxSegundaMatricula: retorno,
    });
  }

  habilitarCheckboxSegundaMatricula = () => {
    const { ctc } = { ...this.state };
    const possuiTresDestinacoes = (ctc.destinacoes !== null && ctc.destinacoes.length === 3);

    this.setState({
      desabilitarCheckboxSegundaMatricula: possuiTresDestinacoes,
    });
  }

  handleSearch = (cpfRow) => {
    const { cpf } = { ...this.state.ctc };
    const { validadeCampos } = { ...this.state };
    let cpfPesquisa = null;

    if (cpf !== null && cpf !== undefined) {
      cpfPesquisa = cpf;
    }
    if (cpfRow !== null && cpfRow !== undefined) {
      cpfPesquisa = cpfRow;
    }

    if (validadeCampos.cpf && cpfPesquisa) {
      this.setState(
        doGet(
          `ctc/cadastro/${cpfPesquisa}`,
          this.trataSucessoResponsePesquisa,
          this.trataErrosResponse,
        ),
      );
    }
  }

  trataSucessoResponsePesquisaCtc = (response) => {
    this.montaFormulario(response);
    this.desabilitarCheckboxMatriculaEDestinacao();
  }

  trataSucessoResponsePesquisaCtcDetalhe = (response) => {
    this.montaFormulario(response);
    this.setState({
      desabilitarCheckboxSegundaMatricula: true,
      desabilitarCheckboxNomeMaeInexistente: true,
    });
  }

  handleSearchCtcInvalida = (protocolo) => {
    if (protocolo) {
      this.setState(
        doGet(
          `ctc/consulta/protocolocomprev/${protocolo}`,
          this.trataSucessoResponsePesquisaCtcDetalhe,
          this.trataErrosResponse,
        ),
      );
    }
  }

  handleSearchCtcRevisao = (protocolo) => {
    if (protocolo) {
      this.setState(
        doGet(
          `ctc/revisao/protocolocomprev/${protocolo}`,
          this.trataSucessoResponsePesquisaCtc,
          this.trataErrosResponse,
        ),
      );
    }
  }

  handleSearchCtc = (protocolo, situacao) => {
    if (protocolo && situacao) {
      this.setState(
        doGet(
          `ctc/protocolocomprev/${protocolo}/${situacao}`,
          this.trataSucessoResponsePesquisaCtcDetalhe,
          this.trataErrosResponse,
        ),
      );
    }
  }

  /**
   * Trata o click no botão de busca por CPF no CNIS.
   */
  handleSearchButton = () => {
    const cpfTouched = true;
    this.setState({ ...this.state, cpfTouched }, this.handleSearch);
  }

  trataSucessoResponsePesquisa = (response) => {
    if(response.data.codigo && response.data.codigo === 3073) {
      const { alerta } = { ...this.state };
      this.setState({
        alerta: {
          ...alerta,
          ...response.data,
        },
        estadoFormulario: 'ctc-ja-emitida-para-a-matricula',
      });
    } else {
      if (response.status === 200) {
        if (response.data === VAZIO) {
          this.setState({
            estadoFormulario: 'sucesso-vazio',
          });
        } else {
          this.montaFormulario(response);
          this.desabilitarCheckboxMatriculaEDestinacao();
        }
      }
    }
  }

  montaFormularioDadosCnpj = (response) => {
    const { ctc } = { ...this.state };
    const { requestPesquisa } = { ...this.state };
    let { validadeCampos } = { ...this.state };   

    const nomeEmpresa = response.data.nome;
    if (nomeEmpresa !== null && nomeEmpresa !== '' && nomeEmpresa !== undefined) {
      validadeCampos[requestPesquisa] = true;
    } else {
      validadeCampos[requestPesquisa] = false;
    }
    ctc[requestPesquisa] = nomeEmpresa;

    this.setState({
      [requestPesquisa]: nomeEmpresa,
      validadeCampos,
    });
  }

  trataSucessoResponsePesquisaCnpj = (response) => {
    this.montaFormularioDadosCnpj(response);
  }

  handleSearchCNPJ = (nome, cnpj) => {
    this.setState(
      { requestPesquisa: nome },
      doGet(
        `pessoas-juridicas/${cnpj}`,
        this.trataSucessoResponsePesquisaCnpj,
        this.trataErrosResponse,
      ),
    );
  }

  handleSearchCnpjButton = (nome, cnpj) => {
    this.setState(this.handleSearchCNPJ(nome, cnpj));
  }

  trataSucessoResponsePesquisaCpf = (response) => {
    this.montaFormularioDadosCpf(response);
  }

  handleSearchCpfButton = () => {
    const cpfTouched = true;
    this.setState({ ...this.state, cpfTouched }, this.handleSearchCPF);
  }

  handleSearchCPF = () => {
    const { cpf } = { ...this.state.ctc };
    this.setState(
      { requestPesquisa: 'cnis' },
      doGet(
        `pessoas-fisicas/${cpf}`,
        this.trataSucessoResponsePesquisaCpf,
        this.trataErrosResponse,
      ),
    );
  }
  
  limparCnpjInvalido = (nome) => {
    let { validadeCampos } = { ...this.state };
    let { ctc } = { ...this.state };
    if (nome === 'nomeEmissor') {
      validadeCampos[nome] = false;
      this.setState({
        validadeCampos,
      });  
    }

    this.setState({
      ctc: {
        ...ctc,
        [nome]: '',
      },
    });
  }
  /**
   * Trata os erros nas requisicoes (busca e submissao de formulario)
   */
  trataErrosResponse = (error) => {
    const { requestPesquisa } = { ...this.state };
    if (error) {
      if (error.status === 404) {
        if(error.data) {
          if(requestPesquisa !== null && (error.data.codigo === 1507)) {
            this.limparCnpjInvalido(requestPesquisa);
          }
        }
      }
      if (error.status === 400) {
        if(error.data) {
          if(requestPesquisa !== null && (error.data.codigo === 1000)) {
            this.limparCnpjInvalido(requestPesquisa);
          }
        }
      }
    }
  }

  handleNewButton = () => {
    this.setState(
      { ...this.getInitialState(), reset: true },
      () => this.setState({ reset: false }, () => window.scrollTo(0, 0)),
    );
  }

  recuperarNomeParticipante = (destinacao) => {
    const { destinatarios } = { ...this.props };
    let nome = VAZIO;
    const index = destinatarios.findIndex(d => (d.value === destinacao.codigoParticipante));
    if (index !== -1) {
      nome = destinatarios[index].label;
    }
    return nome;
  }

  desabilitarCheckboxMatriculaEDestinacao = () => {
    const { acao } = { ...this.state };
    if (acao === 'novo' || acao === 'editar-rascunho' ||
      acao === 'detalhar-ctc' || acao === 'detalhar-ctc-invalida' || acao === 'revisar-ctc') {
      this.verificarDesabilitarCheckboxSegundaMatricula();
    }
  }

  montarListaDestinacaoTempoCertificado = (destinacoes) => {
    let lista = [];
    this.handleChangeComboboxAuxiliar({ value: [], isValid: true }, 'destinacoesTempoCertificado');
    if (destinacoes && destinacoes.length > 0 ) {
      destinacoes.forEach((destinacao) => {
        let destinacaoTempoCertificado = {};
        destinacaoTempoCertificado.value = destinacao.indiceDestinacao;
        destinacaoTempoCertificado.label = this.recuperarNomeParticipante(destinacao); ;
        lista.push(destinacaoTempoCertificado);
      });
    }
    this.handleChangeComboboxAuxiliar({ value: lista, isValid: lista.length > 0 }, 'destinacoesTempoCertificado');
  }

  verificarExibicaoBotaoIncluirDestinacao = () => {
    const { acao } = { ...this.state };
    if((!['detalhar-ctc', 'detalhar-ctc-invalida'].includes(acao))){
      const { ctc } = { ...this.state };
      const { destinacoes } = { ...this.state.ctc };
  
      // const temMatricula1 = (ctc.matricula1 !== null && ctc.matricula1 !== VAZIO);
      const temMatricula2 = (ctc.matricula2 !== null && ctc.matricula2 !== VAZIO);
  
      if (destinacoes) {
        const tamanhoDestinacoes = destinacoes.length;
        switch (tamanhoDestinacoes) {
          case 0:
            return true;
          case 1:
            if (!temMatricula2) {
              return true;
            }
          case 2:
            if (temMatricula2) {
              return true;
            }
          case 3:
            return false;
          default:
            break;
        }        
      } else {
        return true;
      }
    } else {
      return false;
    }
    return false;
  }

  verificarDestinacaoSelecionadaAtividade = () => {
    const { destinacoes } = { ...this.state.ctc };
    const { atividades } = { ...this.state.ctc };
    let lista = [];
    if ((atividades !== null && atividades !== undefined) && atividades.length > 0) {
      atividades.forEach((atividade) => {
        if(atividade.temposCertificados) {
          atividade.temposCertificados.forEach((tempoCertificado) => {
            lista.push(tempoCertificado);
          });
        }
      });
    }
    if ((destinacoes !== null && destinacoes !== undefined) && destinacoes.length > 0) {
      if (lista.length > 0 && destinacoes.length > 0) {
        destinacoes.forEach((destinacao) => {
          lista.forEach((tempoCertificado) => {
              if(destinacao.indiceDestinacao === tempoCertificado.indiceDestinatario) {
                this.desabilitarBotaoExcluirLinhaDestinacaoUtilizada(destinacao.indice);
              }
          });
        });
      }
    }
  }

  desabilitarBotaoExcluirLinhaDestinacaoUtilizada = (indice) => {
    let { linhasDestinacaoDesabilitar } = { ...this.state };
    if (linhasDestinacaoDesabilitar !== undefined) {
      linhasDestinacaoDesabilitar.push(indice);
      this.setState({
        linhasDestinacaoDesabilitar,
      }, this.desabilitarCheckboxMatriculaEDestinacao());
    }
  }

  habilitarBotaoExcluirLinhaDestinacaoUtilizada = (indice) => {
    let { linhasDestinacaoDesabilitar } = { ...this.state };
    if (linhasDestinacaoDesabilitar !== undefined) {
      linhasDestinacaoDesabilitar.splice(indice, 1);
      this.setState({
        linhasDestinacaoDesabilitar,
      },this.habilitarCheckboxMatriculaEDestinacao());
    }
  }

  habilitarCheckboxMatriculaEDestinacao = () => {
    const { acao } = { ...this.state };
    if (acao === 'novo' || acao === 'editar-rascunho' ||
      acao === 'detalhar-ctc' || acao === 'detalhar-ctc-invalida') {
      this.habilitarCheckboxSegundaMatricula();
    }
  }

  criarObjetoMatricula = (matricula1, matricula2) => {
    // O DOMINIO DA CONSTRAINT É (0 , 1).
    // Se a matricula 2 for escolhida quer dizer que a atividade pertence a segunda matricula 
    // campo IN_SEGUNDA_MATRICULA = 1 (SIM)

    let lista = [
      { value: 0, label: `${matricula1} - matrícula 1`},
      { value: 1, label: `${matricula2} - matricula 2`}
    ];
    return lista;
  }

  verificarMudancaNoDestinatarioTempoCertificado = () => {
    let { destinacoes } = { ...this.state.ctc };
    let { atividades } = { ...this.state.ctc };
    let lista = [];
    if ((atividades !== null && atividades !== undefined) && atividades.length > 0) {
      atividades.forEach((atividade) => {
        if(atividade.temposCertificados) {
          atividade.temposCertificados.forEach((tempoCertificado) => {
            lista.push(tempoCertificado);
          });
        }
      });
    }
    if ((destinacoes !== null && destinacoes !== undefined) && destinacoes.length > 0) {
      if (lista.length > 0 && destinacoes.length > 0) {
        destinacoes.forEach((destinacao) => {
          lista.forEach((tempoCertificado) => {
              if (destinacao.indiceDestinacao === tempoCertificado.indiceDestinatario) {
                tempoCertificado.nomeDestinacao = destinacao.nomeParticipante;
              }
          });
        });
      }
    }
  }

  popularListaMatriculasCadastradas = () => {
    const { ctc } = { ...this.state };
    const { listaMatriculasCadastradas  } = { ...this.state };
    const temMatricula1 = (ctc.matricula1 !== null && ctc.matricula1 !== VAZIO);
    const temMatricula2 = (ctc.matricula2 !== null && ctc.matricula2 !== VAZIO);
    let lista = [];
    let alterouMatricula = false;

    if (temMatricula1 && temMatricula2) {
      if (listaMatriculasCadastradas.length > 0) {
        for (let i = 0, tam = listaMatriculasCadastradas.length; i < tam; i += 1) {
          if (listaMatriculasCadastradas[0] !== ctc.matricula1) {
            alterouMatricula = true;
          }
          if (listaMatriculasCadastradas[1] !== ctc.matricula2) {
            alterouMatricula = true;
          }
        };
        if (alterouMatricula) {
          lista = this.criarObjetoMatricula(ctc.matricula1, ctc.matricula2);
        }
      } else {
        lista = this.criarObjetoMatricula(ctc.matricula1, ctc.matricula2);
      }

      this.setState({
        listaMatriculasCadastradas: lista,
      }, this.verificarMudancaNoDestinatarioTempoCertificado());
    }
  }

  formularioCtc = () => (
    <DadosRepositorioCtc
      acao={this.state.acao}
      auth={this.props.auth}
      statePrincipal={this.state}
      handleChange={this.handleChange}
      handleChangeCheckbox={this.handleChangeCheckbox}
      handleSearchButton={this.handleSearchButton}
      handleKeyDown={this.handleKeyDown}
      exibirPainelPrincipalCtc={this.exibirPainelPrincipalCtc}
      handleSearchCpfButton={this.handleSearchCpfButton}
      handleSearchCnpjButton={this.handleSearchCnpjButton}
    />
  );

  montaCorpoCtc = () => {
    const corpoCtc = (
      <DtpTabGroup className="dtp-default">
        {this.montaTabs()}
      </DtpTabGroup>
    );
    return corpoCtc;
  }

  tabCtc = () => (
    <DtpTab
      id="item1"
      className="active"
      title="Dados básicos"
    >
      {this.formularioCtc()}
    </DtpTab>
  );

  tabDestinatarios = () => (
    <DtpTab 
      id="item2" 
      title="Destinatários"
      >
      <CtcDestinacao
        destinatarios={this.props.destinatarios}
        statePrincipal={this.state}
        auth={this.props.auth}
        handleChange={this.handleChange}
        montarListaDestinacaoTempoCertificado={this.montarListaDestinacaoTempoCertificado}
        recuperarNomeParticipante={this.recuperarNomeParticipante}
        desabilitarCheckboxMatriculaEDestinacao={this.desabilitarCheckboxMatriculaEDestinacao}
        verificarExibicaoBotaoIncluirDestinacao={this.verificarExibicaoBotaoIncluirDestinacao}
        popularListaParticipantesEscolhidos={this.popularListaParticipantesEscolhidos}
        atualizarParticipantesEscolhidosAposExcluir={this.atualizarParticipantesEscolhidosAposExcluir}
      />
    </DtpTab>
  )

  tabAtividades = () => (
    <DtpTab
      id="item3"
      title="Atividades"
      onClick={e => this.popularListaMatriculasCadastradas(e, 'item3')}>
      <CtcAtividade
        statePrincipal={this.state}
        auth={this.props.auth}
        handleChange={this.handleChange}
        desabilitarBotaoExcluirLinhaDestinacaoUtilizada={this.desabilitarBotaoExcluirLinhaDestinacaoUtilizada}
        habilitarBotaoExcluirLinhaDestinacaoUtilizada={this.habilitarBotaoExcluirLinhaDestinacaoUtilizada}
        habilitarCheckboxMatriculaEDestinacao={this.habilitarCheckboxMatriculaEDestinacao}
        desabilitarCheckboxMatriculaEDestinacao={this.desabilitarCheckboxMatriculaEDestinacao}
        montarListaDestinacaoTempoCertificado={this.montarListaDestinacaoTempoCertificado}
      />
    </DtpTab>
  )

  isSolicitanteRPPS = () => User.logged().isRPPS();

  montaTabs = () => {
    const listaTabs = [];
    listaTabs.push(this.tabCtc());
    if (this.exibirPainelPrincipalCtc()) {
      listaTabs.push(this.tabDestinatarios());
      listaTabs.push(this.tabAtividades());
    }
    return listaTabs;
  }

  validarCnpj = () => {
    const { ctc } = { ...this.state };
    let emissor = null;
    let homologador = null;
    let lista = [];
    let retorno = false;

    if (ctc.cnpjEmissor !== null && ctc.cnpjEmissor !== VAZIO) {
      emissor = { nome: 'cnpjEmissor', valor: ctc.cnpjEmissor };
      lista.push(emissor);
    }
    if (ctc.cnpjHomologador !== null && ctc.cnpjHomologador !== VAZIO) {
      homologador = { nome: 'cnpjHomologador', valor: ctc.cnpjHomologador };
      lista.push(homologador);
    }
    if (lista.length > 0) {
        lista.forEach((obj) => {
        if (!validarCNPJ(obj.valor)) {
          trataMensagensErro([`O campo ${obj.nome} é inválido. Informe um CNPJ válido.`]);
          return false;
        } else {
          retorno = true;
        }
      });
    } else {
      retorno = true;
    }
    return retorno;
  }

  trataSucesso = () => {
    let mensagemSucesso = VAZIO;
    const operacao = this.state.operacao;
    const { estadoFormulario } = { ...this.state };

    switch (operacao) {
      case 1: {
        mensagemSucesso = 'CTC inserida com sucesso.';
        this.setState({
          estadoFormulario: 'criado',
        });
        this.props.history.goBack();
        break;
      }
      case 2: {
        mensagemSucesso = 'Rascunho da CTC inserido com sucesso.';
        if(estadoFormulario === 'alterar') {
          mensagemSucesso = 'Rascunho da CTC alterado com sucesso.';
        }
        this.setState({
          estadoFormulario: 'criado',
        });
        this.props.history.goBack();
        break;
      }
      case 3: {
        mensagemSucesso = 'CTC revisada com sucesso.';
        this.setState({
          estadoFormulario: 'criado',
        });
        this.props.history.goBack();
        break;
      }
      default: mensagemSucesso = 'CTC inserida com sucesso.';
    }
    trataMensagemSucesso([mensagemSucesso]);
    // this.handleNewButton();
  }

  trataSucessoResponseEnvio = () => {
    this.trataSucesso();
  }

  verificarDataCadastroEVersao = () => {
    let { ctc } = { ...this.state };

    if(ctc.versaoCtc) {
      ctc.versaoCtc = null;
    }
    if(ctc.dtCadastro) {
      ctc.dtCadastro = null;
    }

    this.setState({  ...this.state.ctc, ctc });
  }

  verificarTamanhoDestinacoesEAtividades = () => {
    let { ctc } = { ...this.state };
    if (ctc.destinacoes === null) {
      ctc.destinacoes = [];
    }
    if (ctc.atividades === null) {
      ctc.atividades = [];
    } else {
      ctc.atividades.forEach((atividade) => {
        if(atividade.afastamentos === null) {
          atividade.afastamentos = [];
        }
        if(atividade.temposCertificados === null) {
          atividade.temposCertificados = [];
        }
        if(atividade.temposEspeciais === null) {
          atividade.temposEspeciais = [];
        }
        if(atividade.remuneracoes === null) {
          atividade.remuneracoes = [];
        }
      });
    }
    this.setState({  ...this.state.ctc, ctc });
  }

  verificarCampoPertenceSegundaMatricula = () => {
    let { ctc } = { ...this.state };

    if(ctc.atividades && ctc.atividades.length > 0) {
      ctc.atividades.forEach((atividade) => {
        if (atividade.pertenceSegundaMatricula !== null &&
          atividade.pertenceSegundaMatricula !== '' &&
          atividade.pertenceSegundaMatricula !== undefined) {
            atividade.pertenceSegundaMatricula = Number(atividade.pertenceSegundaMatricula);
        }
      });

    }
  }

  handleSave = (url) => {
    if (this.formularioProntoParaEnvio() || this.rascunhoProntoParaEnvio()) {
      let options;
      if (this.state.chaveConfirmacao) {
        options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
      }

      this.verificarTamanhoDestinacoesEAtividades();
      this.verificarDataCadastroEVersao();
      this.verificarCampoPertenceSegundaMatricula();

      let { ctc } = { ...this.state };
      if (this.state.acao === 'revisar-ctc') {
        doPut(
          url,
          ctc,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
          options,
        );
      } else {
        doPost(
          url,
          ctc,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
          options,
        );
      }
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  confirmSendData = (operacao, protocolo) => {
    let url = VAZIO;
    switch (operacao) {
      case 1: {
        url = 'ctc/cadastro';
        break;
      }
      case 2: {
        url = 'ctc/rascunho';
        break;
      }
      case 3: {
        url = `ctc/revisao/${protocolo}`;
        break;
      }
      default: VAZIO;
    }
    this.setState({
      operacao,
    }, () => this.handleSave(url));
  }

  handleSaveCtc = () => {
    const cnpjValido = this.validarCnpj();
    if (cnpjValido) {
      this.confirmSendData(1, null);
    }
  }

  handleSaveRascunho = () => {
    const cnpjValido = this.validarCnpj();
    if (cnpjValido) {
      this.confirmSendData(2, null);
    }
  }

  handleRevisarCtc = () => {
    const cnpjValido = this.validarCnpj();
    const { ctc } = { ...this.state };
    if (cnpjValido) {
      this.confirmSendData(3, ctc.protocoloComprev);
    }
  }

  exibirPainelPrincipalCtc = () => { // TODO alterar
    const { estadoFormulario } = { ...this.state };
    const { acao } = { ...this.state };
    return (estadoFormulario === 'sucesso-vazio' ||
    estadoFormulario === 'ctc-ja-emitida-para-a-matricula' ||
    estadoFormulario === 'alterar' ||
    acao === 'editar-rascunho' ||
    acao === 'revisar-ctc');
  }

  exibirBotaoSalvar = () => {
    const { acao } = { ...this.state };
    return (!['detalhar-ctc', 'detalhar-ctc-invalida'].includes(acao));
  }

  exibirBotaoRascunho = () => {
    const { acao } = { ...this.state };
    return (!['detalhar-ctc', 'detalhar-ctc-invalida', 'revisar-ctc'].includes(acao));
  }

  controlarExibicaoPainelAtividade = (exibir) => {
    this.setState({
      exibirPainelAtividades: exibir,
    });
  }

  handleBack() {
    this.props.history.push('/repositorioctc/consulta/ctc/rpps');
  }

  render() {
    if (this.state.reset) {
      return null;
    }

    if (this.state.showNoContent) {
      return (
        <DtpNoContent
          primaryText={this.state.noContentPrimaryMessage}
          secondaryText={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />);
    }
    
    let botaoAcaoVoltar;
    let botaoAcaoSalvarRascunho;
    let botaoAcaoPrincipal;

    const configBotaoPrincipal = {
      onClick: this.state.acao === 'revisar-ctc' ? this.handleRevisarCtc: this.handleSaveCtc,
    };

    const configBotaoSalvarRascunho = {
      onClick: this.handleSaveRascunho,
    };

    if (this.exibirBotaoSalvar()) {
      configBotaoPrincipal.permissoes =  ['analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
      configBotaoPrincipal.titulo = 'Salvar';
      configBotaoPrincipal.hint = 'Salvar CTC';
    }

    if (this.exibirBotaoRascunho()) {
      configBotaoSalvarRascunho.permissoes =  ['analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
      configBotaoSalvarRascunho.titulo = 'Salvar rascunho';
      configBotaoSalvarRascunho.hint = 'Salvar o rascunho da CTC';
    }

    botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={() => this.handleBack()}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    if (configBotaoPrincipal.titulo) {
      botaoAcaoPrincipal = (
        <ProtectedItem allowedPermissions={configBotaoPrincipal.permissoes}>
          <Button
            className="dtp-primary right"
            disabled={!this.formularioProntoParaEnvio()}
            title={configBotaoPrincipal.titulo}
            onClick={configBotaoPrincipal.onClick}
            hint={configBotaoPrincipal.hint}
          />
        </ProtectedItem>
      );
    }

    if (configBotaoSalvarRascunho.titulo) {
      botaoAcaoSalvarRascunho = (
        <ProtectedItem allowedPermissions={configBotaoSalvarRascunho.permissoes}>
          <Button
            className="dtp-btn right"
            disabled={!this.rascunhoProntoParaEnvio()}
            title={configBotaoSalvarRascunho.titulo}
            onClick={configBotaoSalvarRascunho.onClick}
            hint={configBotaoSalvarRascunho.hint}
          />
        </ProtectedItem>
      );
    }

    const retorno = (
      <DtpContentContainer>
        {this.montaCorpoCtc()}
        <div className="row">
          { botaoAcaoVoltar }
          { this.exibirBotaoSalvar() ? botaoAcaoPrincipal : '' }
          { this.exibirBotaoRascunho() ? botaoAcaoSalvarRascunho : '' }
        </div>
      </DtpContentContainer>
    );
    return retorno;
  }
}

RepositorioCtc.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      cpf: PropTypes.string,
      protocolo: PropTypes.string,
      acao: PropTypes.string,
      situacao: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

RepositorioCtc.defaultProps = {
  match: null,
  auth: null,
  destinatarios: [],
};

const mapStateToProps = (state) => ({
  destinatarios: state.base.destinatarios,
});

export default connect(mapStateToProps)(RepositorioCtc);



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/RepositorioCtc.jsx